// extracted by mini-css-extract-plugin
export default {"wrapper":"Ygqddc","content":"ujjZz0","footer":"XFjN0F"};